<template>
  <div class="content">
    <NavBar :navBlock='navBlock' :navtitle='navtitle'></NavBar>
    <div class="paddingContent">
      <div class="btn addBtn fr" style="margin-bottom:20px;" @click="$router.push('/addIntroduction')">新增</div>
      <div class="tableWrap" >
        <el-table height='500px' stripe :data="versionList" style="width:100%;">
          <template slot="empty">
            <div class="no-data-container">
              <img src="@/assets/images/common/no_data.png" alt="暂无数据" :style="{width:'244px',height:'139px'}">
            </div>
          </template>
          <el-table-column
            v-for="(item, index) in versionTable" :key="index"
            :prop="item.prop"
            :label="item.label"
            :width="item.width">
          </el-table-column>
          <el-table-column label="操作" width="200"  fixed="right">
            <template slot-scope="scope">
              <el-button @click="$router.push(`/editIntroduction?id=${scope.row.id}`)" type="text" >查看</el-button>
              <el-button @click="delUpdateVersion(scope.row.id)" type="text" >刪除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="paging-block clearfix">
        <el-pagination class="paging fr"
          hide-on-single-page
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-size="10"
          :pager-count='5'
          layout="prev, pager, next, jumper"
          :total="total">
        </el-pagination>
      </div>
    </div>
    <DiaMess v-if="dialogVisible"></DiaMess>

  </div>
</template>

<script>
import NavBar from '@/components/navBar';
import DiaMess from '@/components/dialog';

export default {
  data () {
    return {
      navBlock: '版本更新',
      navtitle:'更新介紹',
      listMenuForm: {
        startTime: '',
        endTime: ''
      },
      versionList: [],
      block:'',
      versionTable: [
        {
          prop: 'version',
          label: '版本名称',
          width: ''
        }, {
          prop: 'platform',
          label: '平台',
          width: ''
        },{
          prop: 'createTime',
          label: '更新时间',
          width: ''
        },
      ],
      total: 0,
      currentPage: 1,
      dialogVisible: false,

    }
  },

  created(){

    this.roleType = localStorage.getItem('roleType')

    if ( this.roleType != null && this.roleType.indexOf('ROLE_GUEST')> -1) {

      this.getVersionList();

    } else {

      this.$router.push('/home');

    }
  },
  activated(){

    this.roleType = localStorage.getItem('roleType');

    if ((this.roleType != null) && (this.roleType.indexOf('ROLE_GUEST')) > -1 && (this.currentPage === 1)) {

      this.getVersionList();
    } else {

      this.$router.push('/home');

    }
  },
  destroyed(){
    this.$message.closeAll();
  },
  methods:{
    getVersionList(){
      this.$get('request/version/v2/versionIntroList', {}, this.$GLOBAL.jsonConfig)
        .then((res) => {
          if (res.code==='00000') {
            console.log(res.data)
            this.versionList = res.data.list;
            this.total = res.data.total;
          } else {
            this.$propMessage(res.message, 'error');
          }
        });
    },
    handleCurrentChange(val){
      this.currentPage = val
      this.getVersionList()
    },
    delUpdateVersion(id){
      let _this = this;
      _this.$get(`request/version/v2/delete/versionIntro/?id=${id}`, _this.$GLOBAL.jsonConfig)
        .then((res) => {
          _this.dialogVisible = true;
          if (res.code==='00000') {
            _this.$propMessage('刪除成功', 'success',
              function(){
                _this.dialogVisible = false;
                _this.currentPage = 1;
                _this.getVersionList();
              });

            
          } else {
            _this.$propMessage(res.message, 'error',
              function(){
                _this.dialogVisible = false;
              });
          }
        });
      console.log('删除')
    },
  },
  components: {
    NavBar,
    DiaMess,

  }
};
</script>
<style lang="less" scoped>
  .content{
    .paddingContent{
      .tableWrap {
        width: 100%;
        height: calc(100% - 152px);
        overflow: auto;
        word-break: break-all;

        @media (max-width: 768px) {
          height: calc(100% - 92px);
        }

        @media (max-width: 420px) {
          height: calc(100% - 112px);
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/version/updateIntList.vue